import React, { useMemo } from "react";
import { ThemeProvider, CssBaseline, createTheme } from "@mui/material";
import { useAppSettings } from "./contexts/AppSettingsContext";

const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { settings } = useAppSettings();
  
  // Create a theme that uses the custom colors from settings
  const theme = useMemo(() => {
    return createTheme({
      palette: {
        mode: "light",
        primary: {
          main: settings.primaryColor || "#5D5FEF",
        },
        secondary: {
          main: settings.secondaryColor || "#4C4DCD",
        },
        background: {
          default: "#ffffff",
          paper: "#f4f6f8",
        },
        text: {
          primary: "#333333",
          secondary: "#666666",
        },
      },
      typography: {
        fontFamily: "'Averta', Arial, sans-serif",
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              borderRadius: "25px",
              padding: "8px 16px",
            },
          },
        },
        MuiIconButton: {
          styleOverrides: {
            root: {
              borderRadius: "12px",
              padding: "8px 16px",
              color: "#333333",
              "&:hover": {
                backgroundColor: `${settings.primaryColor}1A` || "rgba(93, 95, 239, 0.1)",
              },
              "&:focus": {
                backgroundColor: `${settings.primaryColor}33` || "rgba(93, 95, 239, 0.2)",
              },
            },
          },
        },
      },
    });
  }, [settings.primaryColor, settings.secondaryColor]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
